import { ApplicationError } from '@/src/shared/errors';

export class GetUserAndAddressFailedError extends ApplicationError {
  constructor() {
    super('Error', 'Gagal mengambil data user.');
  }
}
export class UpdateAddressError extends ApplicationError {
  constructor() {
    super('Error', 'Gagal memperbarui, silahkan coba beberapa saat lagi');
  }
}
